// const API_URL = "http://localhost:3333";
// const API_URL = "http://localhost:80";
const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = "farmfarmServer";

export default API_URL;
